import React from 'react';

const HireMetrics = ({ metrics }) => {
  if (!metrics) return null;
  return (
    <div className="grid items-center gap-5 rounded-md bg-[#F9F3F3] p-7 shadow-2xl shadow-gray-1/10 md:grid-cols-4  md:justify-between md:p-2 md:px-6">
      {metrics.map(({ title, value }) => (
        <div key={title} className="mx-auto w-10/12 py-4 md:py-10">
          <div className="font-satoshi-bold text-3xl font-bold  md:text-2xl">{title}</div>
          <div className="mt-3 min-h-[2.5rem] font-satoshi-medium font-semibold md:text-sm">
            {value}
          </div>
          <div className="my-3 ring-2 ring-red"></div>
        </div>
      ))}
    </div>
  );
};

export default HireMetrics;
